import React from 'react'
import { useStyles } from './style'
import EWBWLogo from './logo'

const FooterPublic = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <EWBWLogo className={classes.logo} />  © 2022 All Rights Reserved
    </div>
  )
}

export default FooterPublic
